import React from 'react';
import { AccordionContentTransitionProps } from '@modules/digital-signage/model/playlist-schedule.model.ts';

const AccordionContentTransition: React.FC<AccordionContentTransitionProps> = ({
  children
}) => <>{children}</>;

export default AccordionContentTransition;
